




































import { Vue, Component, Prop } from 'vue-property-decorator';
import UploadFileButton from '@/components/UploadFileButton.vue';
import { EButtonType } from '@getaccept/lib-ui';
import { EUploadAttachmentStatus } from '../types/enums/upload-attachment-status';
import { AttachmentService } from '@signing-page/api/attachments/services/attachment.service';
import { AttachmentHelper } from '@signing-page/api/attachments/helpers/attachment.helper';

@Component({
  components: {
    UploadFileButton,
  },
  data: () => ({
    EButtonType,
  }),
})
export default class UploadAttachment extends Vue {
  @Prop() attachmentId: string;
  @Prop() requestedFileName: string;

  file: File = null;
  status: EUploadAttachmentStatus = null;
  failed = false;

  get actionsPrevented(): boolean {
    return !!this.status && !this.failed;
  }

  get fileName(): string {
    return this.file?.name || '';
  }

  handleSelectFile(file: File) {
    this.file = file;
  }

  async upload() {
    if (!this.file) {
      return;
    }

    this.failed = false;
    this.status = EUploadAttachmentStatus.GettingUploadLink;
    const fileExtension: string = this.file.name.split('.').pop();

    try {
      const {
        url,
        headers,
      }: { url: string; headers: string } = await AttachmentService.getUploadLink(
        this.attachmentId,
        fileExtension
      );

      this.status = EUploadAttachmentStatus.UploadingAttachment;
      const formattedHeaders: Record<string, string> = AttachmentHelper.formatHeaders(
        headers,
        this.file.type
      );
      await AttachmentService.upload(this.file, url, formattedHeaders);

      this.status = EUploadAttachmentStatus.Finalizing;
      await AttachmentService.uploadDone(this.attachmentId, this.file.name);

      this.$emit('uploaded');
    } catch (e) {
      this.failed = true;
    } finally {
      this.status = EUploadAttachmentStatus.Completed;
    }
  }
}
